import {ref} from 'vue';
import {defineStore} from 'pinia';
import {
    JudicialPrecedent,
    JudicialPrecedentFilters
} from '~/types/interfaces/entitites/JudicialPrecedentInterface';
import {ErrorInterface} from "~/types/interfaces/ErrorInterface";
import {useCSRF} from "~/stores/csrf";
import {useAPI} from "~/composables/useAPI";

export const useJudicialPrecedentsClientStore = defineStore('judicialPrecedentsClient', () => {
    //https://pinia.vuejs.org/core-concepts/#setup-stores
    //ref()s become state properties
    const error = ref<ErrorInterface | null>(null);
    const judicialPrecedent = ref<JudicialPrecedent>({} as JudicialPrecedent);
    const judicialPrecedents = ref<JudicialPrecedent[]>([]);
    const total = ref<number>(0);
    const useApi = useAPI();
    const csrfStore = useCSRF();

    // computed()s become getters
    const judicialPrecedentsList = computed(() => judicialPrecedents.value)
    const judicialPrecedentsCount = computed(() => total.value)
    const currentEntity = computed(() => judicialPrecedent.value)

    function setJudicialPrecedents(judicialPrecedentsData: []) {
        judicialPrecedents.value = judicialPrecedentsData.data;
        total.value = judicialPrecedentsData.total;
    }

    function setJudicialPrecedent(judicialPrecedentsData: JudicialPrecedent) {
        judicialPrecedent.value = judicialPrecedentsData;
        total.value = judicialPrecedentsData.total;
    }

    function setError(errorData: any) {
        error.value = errorData;
    }

    function resetErrors() {
        error.value = null;
    }

    async function list(perPage, page, queryParams = {}) {
        await useApi.apiFetch(`/client/judicial-precedent/list/${perPage}/${page}`, {
            query: queryParams,
            method: 'GET',
        }).then(({data}) => {
            try {
                setJudicialPrecedents(data);
            } catch (e) {
                console.log("exc", e);
            }

        }).catch(({response}) => {
            if (response) {
                setError(response._data);
            } else {
                setError({
                        application_code: '',
                        data: {},
                        message: 'No hay conexión',
                        status: 'Error',
                    }
                );
            }
        });
    }

    async function listByFilter(data: JudicialPrecedentFilters) {
        await useApi.apiFetch('/client/judicial-precedent/list', {
            method: 'POST',
            body: JSON.stringify(data),
        }).then(({data}) => {
            try {
                setJudicialPrecedents(data);
            } catch (e) {
                console.log("exc", e);
            }

        }).catch(({response}) => {
            if (response) {
                setError(response._data);
            } else {
                setError({
                        application_code: '',
                        data: {},
                        message: 'No hay conexión',
                        status: 'Error',
                    }
                );
            }
        });
    }

    async function view(hash: string) {
        await useApi.apiFetch(`/client/judicial-precedent/view/${hash}`, {
            method: 'GET',
        }).then(({data}) => {
            try {
                setJudicialPrecedent(data);
            } catch (e) {
                console.log("exc", e);
            }
        }).catch(({response}) => {
            if (response) {
                setError(response._data);
            } else {
                setError({
                        application_code: '',
                        data: {},
                        message: 'No hay conexión',
                        status: 'Error',
                    }
                );
            }
        });
    }

    async function download(hash: string, instanceHash: string) {
        return await useApi.apiFetch(`/client/judicial-precedent/${hash}/download/${instanceHash}`, {
            method: 'POST',
        });
    }

    return {
        error,
        currentEntity,
        judicialPrecedentsList,
        judicialPrecedentsCount,
        resetErrors,
        list,
        listByFilter,
        view,
        download
    };
});
